
    <div [class.absolute-center]="absoluteCenter" class="loading-container">
      <ng-content></ng-content>
      <img [src]="src" alt="loading" [style.opacity]="opacity">
    </div>
  